import { styled } from '@mui/system';
import { Button } from 'components/ui';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled('div')`
  display: flex;
  gap: 24px;
`;

export const GusButton = styled(Button)`
  border-radius: 8px;
  box-shadow: 2;
  .MuiButton-root {
    .label {
      font-weight: 400;
      width: 84px;

      svg {
        color: ${theme.palette.primary.main};
        width: 18px;
        height: 18px;
      }
    }
  }
`;
